export default __webpack_public_path__ + "static/media/alertSuccessIcon.e740eebe.svg";